import { React, useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import UserContext from '../../components/User_Context';
import * as api from "../../api/apiConnector.js";
import { dms_style } from "../../styles/style.js";
import * as menu from "../../assets/menus/menu.js";
import Loader from '../../components/ui/loader.js';
import DataTable from 'datatables.net-dt';

function Queue_Manager_Screen(params) {
    const { t } = useTranslation();
    const { currentUser } = useContext(UserContext);
    const [queueList, setQueueList] = useState(null);
    const [refresh, setRefresh] = useState(null);
    const tableRef = useRef(null);
    const dataTableRef = useRef(null);

    const getQueueList = async () => {

        var result = await api.sendMessage("queue/list", {
            user: currentUser()

        })
        return result;
    }

    useEffect(() => {

        (async () => {
            menu.write({ user: currentUser() });
            let _queueList = await getQueueList();
            if (_queueList) {
                setQueueList(_queueList.list.result);
            }
        })();

    }, []);

    useEffect(() => {
        if (queueList && tableRef.current) {
            // Destroy existing DataTable if it exists
            if (dataTableRef.current) {
                dataTableRef.current.destroy();
                dataTableRef.current = null;
            }

            // Initialize new DataTable
            dataTableRef.current = new DataTable(tableRef.current, {
                searching: false,
                pageLength: 50,
                language: {
                    paginate: {
                        previous: '<',
                        next: '>'
                    }
                },
                pagingType: "simple_numbers",
                select: false,
                lengthChange: false,
            });
        }

        // Cleanup function
        return () => {
            if (dataTableRef.current) {
                dataTableRef.current.destroy();
                dataTableRef.current = null;
            }
        };
    }, [queueList, refresh]);

    const getTableRows = () => {
        return queueList.map((i) => { return (getTableRow(i)) });

    }
    const normItem = (item) => {
        if (item.Not_Before) item.Not_Before = new Date(item.Not_Before);
        if (item.Process_Start) item.Process_Start = new Date(item.Process_Start);
        if (item.Process_End) item.Process_End = new Date(item.Process_End);
    }

    const getTableRow = (item) => {

        normItem(item);

        return (<tr data-id={item.Id} style={{ ...dms_style.table_row }}
            onClick={() => {
                openDetailModal(item);
            }}
        >
            <td class="col-2">
                <h6>{item.Id}</h6>
            </td>
            <td class="col-2">
                {item.Process_Status}
            </td>
            <td class="col-2">
                {item.Errors_Count}
            </td>
            <td class="col-2">
                {item.Not_Before ? `${item.Not_Before?.toLocaleString()}` : "-"}
            </td>
            <td class="col-2">
                {item.Process_Start ? ` ${item.Process_Start.toLocaleString()}` : t('notStart', { ns: 'labels' })}
            </td>
            <td class="col-2">
                {item.Process_End ? `${item.Process_End?.toLocaleString()}` : item.Process_Start ? t('inProgress', { ns: 'labels' }) : '-'}
            </td>
        </tr>);
    }

    const openDetailModal = (item) => {
        window.$("#createDetailModal").modal("show");

        const jsonActionDetail = JSON.parse(item.Action_Detail);
        const formattedJsonActionDetail = JSON.stringify(jsonActionDetail, null, 2);
        window.$("#actionDetailJson").text(formattedJsonActionDetail);

        const jsonProcessStatusDetail = JSON.parse(item.Process_Status_Detail);
        const formattedJsonProcessStatusDetail = JSON.stringify(jsonProcessStatusDetail, null, 2);
        window.$("#processStatusJson").text(formattedJsonProcessStatusDetail);
    }

    const createDetailModal = () => {
        return (<>
            <div class="modal fade" id="createDetailModal" tabindex="-1" aria-labelledby="createDetailModal" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="createDetailModalHeader">{t('listItemTitle', { ns: 'labels' })}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label={t('close', { ns: 'labels' })}></button>
                        </div>
                        <div class="modal-body">

                            <h6>{t('actionDetail', { ns: 'labels' })}</h6>
                            <pre id="actionDetailJson" tstyle={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}></pre>

                            <h6>{t('processStatusDetail', { ns: 'labels' })}</h6>
                            <pre id="processStatusJson" tstyle={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}></pre>

                        </div>

                    </div>
                </div>
            </div>
        </>)
    }
    const getTable = () => {

        return (<>
            <table 
                id="empoloyeestbl2" 
                className="table" 
                ref={tableRef}
            >
                <thead>
                    <tr>
                        <th>{t('id', { ns: 'labels' })}</th>
                        <th>{t('status', { ns: 'labels' })}</th>
                        <th>{t('errorCount', { ns: 'labels' })}</th>
                        <th>{t('notBefore', { ns: 'labels' })}</th>
                        <th>{t('start', { ns: 'labels' })}</th>
                        <th>{t('end', { ns: 'labels' })}</th>
                    </tr>
                </thead>
                <tbody>
                    {queueList ? (getTableRows()) : (null)}
                </tbody>
            </table>
        </>);
    }
    return (<>
        <div class="page-titles">
            <ol class="breadcrumb">
                <li><h5 class="bc-title">{t('queueManagerTitle', { ns: 'labels' })}</h5></li>
                <li class="breadcrumb-item"><a href="javascript:void(0)">
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.125 6.375L8.5 1.41667L14.875 6.375V14.1667C14.875 14.5424 14.7257 14.9027 14.4601 15.1684C14.1944 15.4341 13.8341 15.5833 13.4583 15.5833H3.54167C3.16594 15.5833 2.80561 15.4341 2.53993 15.1684C2.27426 14.9027 2.125 14.5424 2.125 14.1667V6.375Z" stroke="#2C2C2C" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6.375 15.5833V8.5H10.625V15.5833" stroke="#2C2C2C" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    {t('home', { ns: 'labels' })} </a>
                </li>
                <li class="breadcrumb-item active"><a href="javascript:void(0)">{t('queueManager', { ns: 'labels' })}</a></li>
            </ol>
        </div>

        <div className="container-fluid">
            <div className="row">


                <div class="col-xl-12">
                    <div class="card">
                        <div class="card-body p-0"></div>
                        <div class="table-responsive active-projects task-table">
                            <div class="tbl-caption">
                                <div className="row">
                                    <div class="col">
                                        <h4 class="heading mb-0 text-start">{t('queueListTitle', { ns: 'labels' })}</h4>
                                    </div>
                                </div>
                            </div>
                            {queueList ? getTable() : <Loader />}


                        </div>
                    </div>
                </div>
            </div>
            {createDetailModal()}
        </div>

    </>)
}

export {
    Queue_Manager_Screen
}